export default __webpack_public_path__ + "static/water-a684ce4178c29790ed11a516de7d3a7e.png";